import ModulesList from './ModulesList.vue';

export default ModulesList;



// WEBPACK FOOTER //
// ./src/pages/modules/list/index.ts